import { useEffect, useRef } from 'react';
import {
  FacebookShareButton,
  FacebookIcon,
  LinkedinShareButton,
  LinkedinIcon,
  TwitterShareButton,
  TwitterIcon,
  EmailShareButton,
  EmailIcon
} from 'react-share';
import Clipboard from 'clipboard'

import styles from './Cell.module.scss';

type ShareDialogProps = {
  cellId: number,
  cellTitle: string,
  cellUrl: string
}

function ShareDialog(props: ShareDialogProps) {

  return (
    <div className={styles.shareDialog}>
      <FacebookShareButton url={props.cellUrl} quote={"Check out this cell from ClusterX: " + props.cellTitle}>
        <FacebookIcon size={32} round />
        Facebook
      </FacebookShareButton>
      <LinkedinShareButton url={props.cellUrl} title={"Check out this cell from ClusterX: " + props.cellTitle} source={"ClusterX"}>
        <LinkedinIcon size={32} round />
        Linkedin
      </LinkedinShareButton>
      <TwitterShareButton url={props.cellUrl} title={props.cellTitle} via={"cluster_x"}>
        <TwitterIcon size={32} round />
        Twitter
      </TwitterShareButton>
      <EmailShareButton url={props.cellUrl} subject={"Shared from ClusterX: " + props.cellTitle} body={"Check out this cell from ClusterX!"} separator={" - "}>
        <EmailIcon size={32} round />
        Email
      </EmailShareButton>

      <div className={styles.shareCopyLink}>
        <span>{props.cellUrl}</span>
        <ClipboardBtn className={styles.shareCopyLinkBtn} copy={props.cellUrl}>Copy Link</ClipboardBtn>
      </div>
    </div>
  )
}

const ClipboardBtn = (props: { copy: string, children?: React.ReactNode, className?: string }) => {
  const btn = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (btn.current !== null) {
      const clipboardEvent = new Clipboard(btn.current, {
        text: (trigger) => {
            return props.copy;
        }
      });

      clipboardEvent.on('success', function(e) {
        const origText = e.trigger.textContent;

        e.trigger.textContent = 'Copied!';

        setTimeout(() => {
          e.trigger.textContent = origText;
        }, 3000);
      });
    }
  }, [props.copy]);

  return <button data-clipboard-text={props.copy} ref={btn} className={props.className}>{ props.children }</button>;
}



export default ShareDialog;
